import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { DialogLinkService } from 'shared/routed-dialog/dialog-link.service';
import { StationsService } from 'shared/stations-service/stations.service';
import { TimeDisplayService } from 'shared/time-display-service/time-display.service';

@Component({
    selector: 'ce-tile-basic',
    templateUrl: './tile-basic.component.html',
    styleUrls: ['./tile-basic.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileBasicComponent {
    @Input() stationId;
    @Input() title: string;
    @Input() hideOpenDialogBtn = false;
    @Output() openDialog = new EventEmitter<void>();
    @Input() dialogRoute: (string | number)[];
    @Input() showHistoricNotice = false;
    @Input() loading = true;
    @Input() showTitleWarning = false;

    currentTime$ = this.timeDisplayService.timeObservable$;

    constructor(
        private readonly dialogLink: DialogLinkService,
        public stations: StationsService,
        private readonly timeDisplayService: TimeDisplayService
    ) {}

    openDialogClick() {
        if (this.dialogRoute) {
            this.dialogLink.open(this.dialogRoute);
        }
        this.openDialog.emit();
    }
}
